<template>
    <div class="grid grid-cols-2 gap-3">
        <div v-if="useMyNaPromo === 'card'"
             @click="$emit('myNaClicked')"
             class="cursor-pointer group relative bg-zinc-900 overflow-hidden text-left flex flex-col h-full ring-1 ring-amber-500/30 shadow-lg shadow-amber-500/10 rounded-xl">
            <button class="absolute top-2 right-2 z-20 w-7 h-7 rounded-full bg-black/50 backdrop-blur-sm hover:bg-black/70 flex items-center justify-center transition-colors" aria-label="Dismiss">
                <X class="w-3.5 h-3.5 text-white/70" />
            </button>
            <div class="relative w-full aspect-[3/4] overflow-hidden flex-shrink-0 ">
                <img src="https://sm.naughtycdn.com/images/feeds/myna-promo.png" alt="Sponsor Profile Page" class="w-full h-full object-cover object-top">
                <div class="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/30"></div>
                <!--<div class="absolute top-3 left-3">
                    <div class="inline-flex items-center gap-1 px-2 py-1 rounded-md min-h-[22px] text-xs font-bold tracking-wide uppercase bg-amber-500/90 text-black shadow-sm">
                        <Sparkles class="w-3 h-3" />
                        New
                    </div>
                </div>-->
                <div class="absolute inset-0 flex flex-col items-center justify-center px-3 text-center">
                    <h3 class="text-white font-bold leading-tight mb-1 text-lg">Your Sponsor Profile</h3>
                    <p class="text-white/70 leading-snug max-w-[90%] text-xs">Every star builds your bragging rights</p>
                </div>
                <div class="absolute bottom-0 left-0 right-0 p-2.5">
                    <div class="flex items-center justify-center gap-3">
                        <div class="flex items-center gap-1">
                            <img src="https://sm.naughtycdn.com/images/landers/prize/NA-Star.png" alt="" class="w-3 h-3">
                            <span class="text-white/80 text-[10px] font-semibold">Stars</span>
                        </div>
                        <div class="flex items-center gap-1">
                            <Trophy class="w-3 h-3 text-amber-400" />
                            <span class="text-white/80 text-[10px] font-semibold">Rank</span>
                        </div>
                        <div class="flex items-center gap-1">
                            <Award class="w-3 h-3 text-amber-400" />
                            <span class="text-white/80 text-[10px] font-semibold">Badges</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4 flex flex-col flex-1">
                <p class="text-white/50 mb-2 text-sm">Earn badges &amp; climb the leaderboard</p>
                <div class="mt-auto">
                    <button v-if="isUserLoggedIn" type="button" class="w-full flex items-center justify-center gap-1.5 bg-white/10 hover:bg-white/15 border border-white/15 text-white font-bold rounded-lg transition-all active:scale-95 py-2.5 text-sm" data-id="element-140">
                        View Your Page
                        <ExternalLink class="w-3.5 h-3.5" />
                    </button>
                    <button v-else type="button" class="w-full flex items-center justify-center gap-1.5 bg-white/10 hover:bg-white/15 border border-white/15 text-white font-bold rounded-lg transition-all active:scale-95 py-2.5 text-sm" data-id="element-140">
                        Build Your Page
                    </button>
                </div>
            </div>
        </div>
        <!-- Plain div, not <Link> - this never uses Inertia's own navigation
             (href was just "#" as a placeholder), and Link's own click
             handler binds to the underlying <a> BEFORE this @click
             fallthrough listener does, firing its own visit() to the
             current page first regardless of our .prevent - a real race
             against handleCardClick's own navigation that explained the
             recurring "tap audition -> bounces back" bug. See
             readme_reels_ios_edge_swipe_back_bug.md. -->
        <div
            v-for="post in posts"
            :key="post.id"
            role="button"
            tabindex="0"
            @click="handleCardClick(post)"
            @keydown.enter="handleCardClick(post)"
            @keydown.space.prevent="handleCardClick(post)"
            @touchstart.passive="handleTouch(post)"
            :class="[
                'group relative rounded-2xl overflow-hidden bg-zinc-900 transition-all active:scale-[0.97] text-left flex flex-col cursor-pointer',
                isBillerExpired(post) ? 'opacity-50' : '',
                post.sponsored_by_user && post.stars_given_by_user > 0
                    ? 'ring-2 ring-blue-500/40 shadow-lg shadow-blue-500/20'
                    : 'ring-1 ring-white/10 active:ring-white/20'
            ]"
        >
            <!-- Thumbnail -->
            <div class="relative aspect-[3/4] overflow-hidden bg-zinc-800 rounded-t-2xl shrink-0">
                <picture v-if="requiresAgeVerification">
                    <source
                        :srcset="post.lock.start_card_video_images?.image_600x1066_webp"
                        type="image/webp"/>
                    <source
                        :srcset="post.lock.start_card_video_images?.image_600x1066 ?
                            post.lock.start_card_video_images.image_600x1066 :
                            'https://sm.naughtycdn.com/images/brokenImage.png'"
                        type="image/jpeg"/>

                    <img
                        v-show="!post.showVideo"
                        :title="post.title"
                        :alt="post.title"
                        alt="Image"
                        width="297"
                        height="526"
                        :class="{
                            'is_not_vertical h-full w-full object-contain text-white': !post.is_vertical,
                            'is_vertical h-full w-full object-cover text-white': post.is_vertical,
                            locked: post.is_locked,
                            unlocked: !post.is_locked,
                        }"
                        :src="post.lock.start_card_video_images?.image_600x1066_webp"/>
                </picture>
                <picture v-else>
                    <source
                        :srcset="post.start_card_images?.image_600x1066_webp"
                        type="image/webp"/>
                    <source
                        :srcset="post.start_card_images?.image_600x1066 ?
                                        post.start_card_images.image_600x1066 :
                                        'https://sm.naughtycdn.com/images/brokenImage.png'"
                        type="image/jpeg"/>

                    <img
                        v-show="!post.showVideo"
                        :title="post.title"
                        :alt="post.title"
                        alt="Image"
                        width="297"
                        height="526"
                        :class="{
                            'is_not_vertical h-full w-full object-contain text-white': !post.is_vertical,
                            'is_vertical h-full w-full object-cover text-white': post.is_vertical,
                            locked: post.is_locked,
                            unlocked: !post.is_locked,
                        }"
                        :src="post.start_card_images?.image_600x1066_webp"/>
                </picture>

                <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

                <!-- New Badge -->
                <!--<div v-if="post.is_new" class="absolute top-2 left-2">
                    <span class="inline-flex items-center px-1.5 py-1 rounded-md min-h-[22px] bg-white/15 backdrop-blur-md border border-white/20 text-white text-xs font-bold uppercase tracking-wide">
                        New
                    </span>
                </div>-->

                <!-- Only show status badge for 'almost' status on mobile -->
                <div v-if="isBillerExpired(post)" class="absolute top-2 right-2">
                    <div class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-bold backdrop-blur-sm bg-zinc-700/80 text-white/60 border border-white/10">
                        <Ban class="w-2.5 h-2.5 flex-shrink-0" />
                        Expired
                    </div>
                </div>
                <div v-else-if="post.is_near_goal" class="absolute top-2 right-2">
                    <StatusBadgeCompact :audition="post" />
                </div>

                <!-- Expiry FOMO Pill -->
                <div v-if="!isBillerExpired(post) && !post.star_goal_reached && isExpiringSoon(post)" class="absolute top-2 left-2 max-w-[calc(100%-3.5rem)]">
                    <div :class="[
                        'inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[9px] font-bold truncate',
                        getExpiresInDays(post) <= 2
                            ? 'bg-rose-600/80 text-white'
                            : getExpiresInDays(post) <= 5
                                ? 'bg-orange-500/80 text-white'
                                : 'bg-amber-500/80 text-white'
                    ]">
                        🔥 {{ getFomoLabel(post) }}
                    </div>
                </div>

                <!-- Loading Spinner -->
                <div
                    v-if="post.buffering && post.showVideo && !post.is_locked"
                    class="loading spinner z-[100]">
                    <span class="text-white"></span>
                </div>

                <!-- Video Element - Always in DOM, controlled by visibility -->
                <video
                    v-if="!requiresAgeVerification"
                    :ref="el => { if (el) videoRefs.set(post.id, el) }"
                    v-show="post.showVideo && !post.is_locked"
                    :poster="post.start_card_images?.image_600x1066_webp"
                    class="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-300"
                    :title="post.title"
                    :alt="post.title"
                    muted
                    loop
                    webkit-playsinline
                    playsinline
                    preload="metadata"
                    @loadstart="handleLoadStart(post)"
                    @waiting="handleWaiting(post)"
                    @playing="handlePlaying(post)"
                    @canplay="handleCanPlay(post)"
                    @error="handleError(post, $event)"
                    @pause="handlePause(post)"
                    disableremoteplayback
                >
                    <source
                        :src="post.videoUrl_mp4_unbranded || post.videoUrl_mp4"
                        type="video/mp4"
                    />
                </video>

                <!-- Bottom Section - Progress/Status -->
                <div class="absolute bottom-0 left-0 right-0 p-2.5">
                    <!-- Expired Status -->
                    <div v-if="isBillerExpired(post)" class="w-full py-1.5 px-2 bg-zinc-700/30 border border-white/10 rounded-lg flex items-center justify-center gap-1">
                        <Ban class="w-3 h-3 text-white/40" />
                        <span class="text-white/40 text-xs font-bold">Expired</span>
                    </div>

                    <!-- Active Status (new/almost) -->
                    <template v-else-if="!post.star_goal_reached">
                        <div
                            :class="[
                                'relative h-1.5 bg-white/15 rounded-full overflow-hidden mb-1.5',
                                post.is_near_goal ? 'animate-pulse' : ''
                            ]"
                        >
                            <div
                                :class="[
                                    'absolute inset-y-0 left-0 rounded-full transition-all duration-300',
                                    post.sponsored_by_user && post.stars_given_by_user > 0
                                        ? 'bg-gradient-to-r from-blue-400 to-blue-300'
                                        : 'bg-gradient-to-r from-blue-500 to-blue-400'
                                ]"
                                :style="{ width: `${Math.min(getPercentage(post), 100)}%` }"
                            />
                        </div>

                        <div class="flex items-center justify-between text-xs">
                            <span class="text-white/60 font-medium">
                                {{ Math.round(getPercentage(post)) }}%
                            </span>
                            <span class="text-white font-bold">
                                {{ getStarsNeeded(post) }} to go
                            </span>
                        </div>
                    </template>

                    <!-- Released Status -->
                    <a
                        v-if="post.release_status == 2 && post.scene_slug"
                        :href="route(routePrefix + '.scene.show', post.scene_slug)"
                        target="_blank"
                        @click.stop="handleWatchReleasedSceneClick(post)"
                        class="w-full py-1.5 px-2 bg-emerald-500/90 hover:bg-emerald-600 rounded-lg flex items-center justify-center gap-1.5 transition-colors"
                    >
                        <Play class="w-3 h-3 text-white" fill="white" />
                        <span class="text-white text-xs font-bold">
                            Released
                        </span>
                    </a>

                    <!-- Production Status -->
                    <div
                        v-if="post.release_status == 1"
                        class="w-full py-1.5 px-2 bg-amber-500/20 border border-amber-500/30 rounded-lg flex items-center justify-center gap-1"
                    >
                        <Film class="w-3 h-3 text-amber-400" />
                        <span class="text-amber-300 text-xs font-bold">
                            In Production
                        </span>
                    </div>

                    <!-- Sponsored Status -->
                    <div
                        v-if="post.star_goal_reached && !post.release_status"
                        class="w-full py-1.5 px-2 bg-sky-500/20 border border-sky-500/30 rounded-lg flex items-center justify-center gap-1"
                    >
                        <Check class="w-3 h-3 text-sky-400" :stroke-width="3" />
                        <span class="text-sky-300 text-xs font-bold">
                            Sponsored
                        </span>
                    </div>
                </div>
            </div>

            <!-- Title & Performer -->
            <div class="p-2.5 flex flex-col min-h-[76px]">
                <h3 class="text-white font-bold text-sm leading-tight line-clamp-2 h-[36px] mb-1">
                    {{ post.title }}
                </h3>
                <p class="text-white/50 text-xs line-clamp-1 h-[18px]">
                    {{ post.creator.name }}
                </p>

                <!-- User's contribution (if sponsored) -->
                <div
                    v-if="post.sponsored_by_user && post.stars_given_by_user > 0"
                    class="mt-auto flex items-center gap-1"
                >
                    <span class="text-blue-400 text-xs font-bold">
                        You: {{ post.stars_given_by_user }}
                    </span>
                    <img :src="STAR_ICON_URL" alt="" class="w-2.5 h-2.5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {Play, Film, Check, Sparkles, X, Trophy, Award, ExternalLink, Ban} from 'lucide-vue-next'
import StatusBadgeCompact from './StatusBadgeCompact.vue'
import { ref, nextTick, onBeforeUnmount } from 'vue'
import {trackAuditionAnalyticsEvent} from "@/Helpers/auditions";

const props = defineProps({
    posts: {
        type: Array,
        required: true
    },
    isUserLoggedIn: {
        type: Boolean,
    },
    routePrefix: {
        type: String
    },
    requiresAgeVerification: {
        type: Boolean,
        default: false
    },
    useMyNaPromo: {
        type: String,
        required: false,
    }
})

const STAR_ICON_URL = 'https://sm.naughtycdn.com/images/landers/prize/NA-Star.png'

const emit = defineEmits(['videoClick', 'navigateToScene', 'showVideo', 'hideVideo', 'setBufferingState', 'goToFeed', 'prefetchFeed', 'myNaClicked'])

const currentPlayingItem = ref(null)
const videoRefs = ref(new Map())

const handleLoadStart = (post) => {
    console.log(`[${post.id}] loadstart - Starting to load video`)
    post.buffering = true
}

const handleWaiting = (post) => {
    console.log(`[${post.id}] waiting - Buffering...`)
    post.buffering = true
}

const handlePlaying = (post) => {
    console.log(`[${post.id}] playing - ✓ Video is now playing`)
    post.buffering = false
}

const handleCanPlay = (post) => {
    console.log(`[${post.id}] canplay - Video ready to play`)
    post.buffering = false
}

const handleError = (post, event) => {
    const video = event.target
    console.error(`[${post.id}] ✗ Video error:`, {
        error: video.error,
        code: video.error?.code,
        message: video.error?.message,
        networkState: video.networkState,
        readyState: video.readyState,
        src: video.currentSrc
    })
    post.buffering = false
}

const handlePause = (post) => {
    console.log(`[${post.id}] pause - Video paused`)
}

const stopCurrentVideo = () => {
    if (currentPlayingItem.value) {
        const videoEl = videoRefs.value.get(currentPlayingItem.value.id)
        if (videoEl) {
            console.log(`[${currentPlayingItem.value.id}] Stopping current video`)
            videoEl.pause()
            videoEl.currentTime = 0
        }
        currentPlayingItem.value.showVideo = false
        currentPlayingItem.value = null
    }
}

const handleTouch = async (post) => {
    // Prefetch feed page in background so click-to-open is instant
    emit('prefetchFeed', post)

    console.log('=== Touch Event ===', {
        id: post.id,
        title: post.title,
        isLocked: post.is_locked,
        hasVideoUrl: !!(post.videoUrl_mp4_unbranded || post.videoUrl_mp4),
        currentlyPlaying: currentPlayingItem.value?.id
    })

    // Don't play expired or locked videos
    if (isBillerExpired(post) || post.is_locked) {
        console.log(`[${post.id}] ✗ Video is locked`)
        return
    }

    // Stop any currently playing video
    if (currentPlayingItem.value && currentPlayingItem.value.id !== post.id) {
        stopCurrentVideo()
    }

    // Show the video element
    post.showVideo = true
    currentPlayingItem.value = post

    // Wait for DOM update
    await nextTick()

    // Get the video element
    const videoEl = videoRefs.value.get(post.id)

    if (!videoEl) {
        console.error(`[${post.id}] ✗ Video element not found in refs`)
        return
    }

    console.log(`[${post.id}] Video element state:`, {
        readyState: videoEl.readyState,
        networkState: videoEl.networkState,
        paused: videoEl.paused,
        currentTime: videoEl.currentTime,
        duration: videoEl.duration,
        src: videoEl.currentSrc
    })

    // Load the video
    videoEl.load()

    try {
        // Attempt to play
        const playPromise = videoEl.play()

        if (playPromise !== undefined) {
            await playPromise
            console.log(`[${post.id}] ✓ Play promise resolved successfully`)
        }
    } catch (error) {
        console.error(`[${post.id}] ✗ Play failed:`, {
            name: error.name,
            message: error.message,
            videoState: {
                readyState: videoEl.readyState,
                networkState: videoEl.networkState,
                error: videoEl.error
            }
        })
    }
}

const handleCardClick = (post) => {
    console.log(`[${post.id}] Card clicked - navigating to feed`)
    emit('goToFeed', post)
}

const isBillerExpired = (post) => post.feed_post_status == 3

const getExpiresInDays = (post) => {
    if (!post.expires_at) return null
    return Math.ceil((new Date(post.expires_at) - new Date()) / (1000 * 60 * 60 * 24))
}

const isExpiringSoon = (post) => {
    const days = getExpiresInDays(post)
    return days !== null && days >= 0 && days <= 7
}

const getFomoLabel = (post) => {
    const days = getExpiresInDays(post)
    if (days === null) return ''
    if (days === 0) return "Don't miss out — ends today!"
    if (days <= 2) return 'This is your last chance'
    if (days <= 5) return 'Going away soon'
    return 'This will leave soon'
}

const getPercentage = (post) => {
    return (post.likes / post.star_goal) * 100
}

const getStarsNeeded = (post) => {
    return Math.max(0, post.star_goal - post.likes)
}

// Cleanup on component unmount
onBeforeUnmount(() => {
    console.log('Component unmounting - stopping all videos')
    stopCurrentVideo()
    videoRefs.value.clear()
})

const handleWatchReleasedSceneClick = (post) => {
    trackAuditionAnalyticsEvent('Watch Scene Button Clicked', post);
    window.open(route(props.routePrefix + '.scene.show', post.scene_slug), '_blank')
}
</script>
